import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";
import { Store } from "@ngrx/store";
import {
    fetchPayments,
    getPayment
} from "../../store/payment/payment.actions";
import { getPaymentsSelector, getPaymentSelector } from '@store/payment/payment.selectors';
import { IState } from '@models/index';
import { HelperService } from '../helper/helper.service';

@Injectable({
  providedIn: "root"
})
export class PaymentnService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ payment: IState }>
  ) {}

  getPaymentsSelector(): Observable<IState> {
    return this.store.select(getPaymentsSelector);
  }

  getPaymentSelector(): Observable<IState> {
    return this.store.select(getPaymentSelector);
  }

  fetchPayments(page: number, filterOptions: any): void {
    this.store.dispatch(fetchPayments({ page, filterOptions }));
  }

  fetchPayment(paymentID: string): void {
    this.store.dispatch(getPayment({ paymentID }))
  }

  getPayments(page: number, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);
    
    return this.http.get(`${this.backendUrl}/payments?${queryString}`);
  }

  getPayment(paymentID: string) {
    return this.http.get(`${this.backendUrl}/payments/payment/${paymentID}`);
  }
}
